
import * as THREE from 'three';

export function generateShader(){
    const shaderMaterial = new THREE.ShaderMaterial({
        vertexShader: `
          uniform float u_time;
          uniform float opacity;
          //该变量用于传坐标给片元着色器
          varying vec2 v_uv;
          //用于同步传值
          varying float totalWave;
          void main() {
            // 2. 多频率水波叠加（不同波长+不同速度，更真实）
            float wave1 = position.x + sin(position.x + u_time); // 次波：X 方向细纹
            float wave2 = position.y * (1.6+ sin(position.x - u_time)) ; // 次波：X 方向细纹
            float wave3 = position.z + sin(position.y + u_time); // 次波：X 方向细纹
            
            // 3. 总水波高度（叠加所有波）
            totalWave = wave2;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position.x, wave2, position.z, opacity);
          }
        `,
        fragmentShader: `
          uniform vec2 u_resolution; //画布尺寸（宽，高）
          uniform vec3 pointColor;
          uniform float u_time;
          uniform float opacity;
          //该变量用于接受顶点着色器传入的顶点坐标
          varying vec2 v_uv;
          //用于同步传值
          varying float totalWave;
          void main() {
            float distance = length(v_uv)*2.0; // position.xy = (x, y)，length 计算到原点的距离
            float wave1 = sin(distance * 3.0 - u_time * 2.0) * 0.1;  // 主波：环形扩散
            gl_FragColor = vec4(sin(totalWave)*10.0, cos(totalWave)*1.0,0.0,0.8);
          }
        `,
        uniforms: {
          u_time: {type: 'f', value: 0.0},
          pointColor: { value: new THREE.Color(1.0, 0.0, 0.0) }, 
          opacity: { value: 1.0 }
        },
        transparent: true
      });
      return shaderMaterial;
}